const readNonEmptyString = (value: unknown): string | null =>
  typeof value === 'string' && value.trim().length > 0 ? value.trim() : null;

/** Same visual weight as lesson type icons in journey nodes. */
export const MODULE_TYPE_ICON_SIZE = 9;

const FLOW_KIND_ICON_NAMES: Record<string, string> = {
  trainer: 'courses',
  training: 'trainings',
  arcade: 'game',
  course: 'courses',
  catalog: 'modules',
};

export const resolveModuleFlowKind = (
  properties?: Record<string, unknown>,
): string | null => {
  if (!properties) {
    return null;
  }

  const flowKind = readNonEmptyString(properties.flow_kind);

  /* admin-api resolved the module id from `coursemodules`: a module inside a course, not a trainer. */
  if (
    properties.module_kind === 'course_module' &&
    (!flowKind || flowKind === 'trainer')
  ) {
    return 'course';
  }

  if (flowKind) {
    return flowKind;
  }

  if (readNonEmptyString(properties.training_id)) {
    return 'training';
  }

  if (readNonEmptyString(properties.arcade_id)) {
    return 'arcade';
  }

  if (readNonEmptyString(properties.module_id)) {
    return 'trainer';
  }

  return null;
};

export const getModuleTypeIconName = (
  properties?: Record<string, unknown>,
): string | null => {
  const flowKind = resolveModuleFlowKind(properties);

  if (!flowKind) {
    return null;
  }

  return FLOW_KIND_ICON_NAMES[flowKind] ?? null;
};

/** Events about a catalog item itself (its card, page or start), not about a lesson inside it. */
const MODULE_CONTEXT_EVENT_PREFIXES = [
  'trainer_',
  'module_',
  'training_',
  'arcade_',
  'course_',
];

export const isModuleContextEventKey = (translationKey: string): boolean =>
  MODULE_CONTEXT_EVENT_PREFIXES.some((prefix) => translationKey.startsWith(prefix));
